export default {"src":"/_next/static/media/symbol-icon-fb.8ad09934.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};